module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pagination.total > 0) ? _c('b-pagination', {
    attrs: {
      "total-rows": this.pagination.total,
      "per-page": _vm.pagination.perPage,
      "aria-controls": "my-table"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca365bcc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Pagination.vue
// module id = 1914
// module chunks = 1